
// @ts-nocheck


export const localeCodes =  [
  "en",
  "da",
  "de",
  "es",
  "fi",
  "fr-CA",
  "fr-FR",
  "it",
  "nl",
  "no",
  "pt-BR",
  "pt-PT",
  "sv"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_e8c2d68f",
      load: () => import("#nuxt-i18n/e8c2d68f" /* webpackChunkName: "locale_en_46json_e8c2d68f" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_fa565fa1",
      load: () => import("#nuxt-i18n/fa565fa1" /* webpackChunkName: "locale_da_46json_fa565fa1" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_d803b688",
      load: () => import("#nuxt-i18n/d803b688" /* webpackChunkName: "locale_de_46json_d803b688" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_b5df492d",
      load: () => import("#nuxt-i18n/b5df492d" /* webpackChunkName: "locale_es_46json_b5df492d" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_b98207cc",
      load: () => import("#nuxt-i18n/b98207cc" /* webpackChunkName: "locale_fi_46json_b98207cc" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_ab1b470e",
      load: () => import("#nuxt-i18n/ab1b470e" /* webpackChunkName: "locale_fr_45CA_46json_ab1b470e" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_ab5161b1",
      load: () => import("#nuxt-i18n/ab5161b1" /* webpackChunkName: "locale_fr_45FR_46json_ab5161b1" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_112e15d5",
      load: () => import("#nuxt-i18n/112e15d5" /* webpackChunkName: "locale_it_46json_112e15d5" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_7b35d7d6",
      load: () => import("#nuxt-i18n/7b35d7d6" /* webpackChunkName: "locale_nl_46json_7b35d7d6" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_b0f00b49",
      load: () => import("#nuxt-i18n/b0f00b49" /* webpackChunkName: "locale_no_46json_b0f00b49" */),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_f90adaed",
      load: () => import("#nuxt-i18n/f90adaed" /* webpackChunkName: "locale_pt_45BR_46json_f90adaed" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_30424045",
      load: () => import("#nuxt-i18n/30424045" /* webpackChunkName: "locale_pt_45PT_46json_30424045" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_ad2799ec",
      load: () => import("#nuxt-i18n/ad2799ec" /* webpackChunkName: "locale_sv_46json_ad2799ec" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-CA",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/fr-CA.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-FR",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-BR",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/pt-BR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-PT",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/pt-PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/sv.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-CA",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/fr-CA.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-FR",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-BR",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/pt-BR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-PT",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/pt-PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal@2/apps/clientportal/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/